import React from 'react';
import {Stack, Tooltip} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import {getValidationStepsForProductType} from '../../product/constants/validationStepSelectors';

/**
 * Displays validation status icons for a report
 * @param {Object} props
 * @param {Object} props.validation - Validation data object
 * @param {string} props.productTypeValue - Product type value
 * @returns {JSX.Element}
 */
const ValidationStatusIcons = ({validation = {}, productTypeValue = null}) => {
    const validationSteps = getValidationStepsForProductType(productTypeValue);

    const getStatusIcon = (entry) => {
        if (!entry) {
            return <HourglassBottomIcon color="disabled"/>;
        }

        if (entry.passed === true) {
            return <CheckCircleOutlineIcon color="success"/>;
        }

        if (entry.passed === false) {
            return <ErrorOutlineIcon color="error"/>;
        }

        return <HourglassBottomIcon color="disabled"/>;
    };

    return (
        <Stack direction="row" spacing={1} alignItems="center">
            {validationSteps.map((step, idx) => {
                const entry = validation?.[idx];
                const Icon = getStatusIcon(entry);

                return (
                    <Tooltip key={step.key} title={step.label} arrow placement="top">
                        <span>{Icon}</span>
                    </Tooltip>
                );
            })}
        </Stack>
    );
};

export default ValidationStatusIcons;
